import axios from "axios";
import {url} from "../../../utils/urls";

// api parameters
const withCredentials = true;
const headers = {
    json: {
        'Content-Type': 'application/json'
    }
};
export const getChildPublishersRequest = (requestData) => {
    return axios.post(`${url.acs.childpublishers}`, requestData, { headers: headers.json, withCredentials });
};